<template>
  <div>
    <div class="upload-other-label">附件文件 :支持图片格式JPG，PNG，和压缩包文件RAR,ZIP</div>
    <div class="upload-other-label-vest">(非必选，可传工程文件或版权证明文件)</div>
    <div class="s">
      <div v-if="status === 'succ'" class="upload-video-succ">
        <span class="btn-remove" @click="handleRemoveVideoResource"><i class="el-icon-delete" /></span>
        <i class="icon-upload-succ" />
        <p class="upload-succ-text">
          上传成功
        </p>
      </div>
      <div v-else-if="status === 'po'" class="upload-video-process">
        <p class="upload-process-text">
          正在处理中...
        </p>
      </div>
      <el-upload v-else class="upload-video-other" accept=".mp4,.rar,.png,.jpg,.jpeg,.zip" drag action=""
        :http-request="handleVideoUpload">
        <p class="upload-info">
          您可拖拽文件到此处
        </p>
        <p class="upload-sub">
          或<span class="btn">浏览</span>以选择文件
        </p>
      </el-upload>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { encryptUpload } from '@/api/upload'

import Loading from '@/components/Loading'

export default {
  name: 'UploadOther',
  components: {
    Loading,
  },
  props: {
    disable: {
      type: Boolean,
      default: false,
    },
    preResourceId: {
      type: Number,
      default: 0,
    },
    preResourceUrl: {
      type: String,
      default: '',
    },
    prePreviewUrl: {
      type: String,
      default: '',
    },
    platform: {
      type: String,
      default: 'pc',
    },
    width: {
      type: Number,
      default: 274,
    },
    height: {
      type: Number,
      default: 154,
    },
    videoWidth: {
      type: Number,
      default: 1920,
    },
    mobileVideoWidth: {
      type: Number,
      default: 720,
    },
    mobileVideoHeight: {
      type: Number,
      default: 1280,
    },
    videoHeight: {
      type: Number,
      default: 1080,
    },
    size: {
      type: Number,
      default: 100 * 1024 * 1024,
    },
    originateClient: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      chunkSize: 2097152, // 2M 作为一个chunk
      fileMaxSize: this.size, // 100M
      status: 'wait', // wait: 等待上传 process: 上传中 succ: 上传成功
      uploadComplete: 0,
      uploadSpeed: '',
      uploadPreLoaded: 0,
      uploadLoaded: 0,
      speedTimer: null,
      resourceId: this.preResourceId,
      preview: this.prePreviewUrl,
      confirmDialogText: '',
    }
  },
  computed: {
    ...mapState({
      common: (state) => {
        return {
          token: state.userInfo.token,
          open_id: state.userInfo.open_id,
        }
      },
    }),
  },
  watch: {
    confirmDialogText(text) {
      if (text) {
        this.$emit('error', text)
      }
      this.confirmDialogText = ''
    },
    preResourceId(id) {
      if (id) {
        this.resourceId = id
        this.status = 'succ'
      }
    },
    preResourceUrl(url) {
      if (url) {
        this.resourceUrl = url
      }
    },
    prePreviewUrl(url) {
      if (url) {
        this.preview = url
      }
    },
  },
  methods: {
    handleSelectUpload() {
      this.$refs.uploadInput.click()
    },

    getErrorMsg(err) {
      if (!err) return ''
      if (err.msg) return err.msg
      if (err.resp_common && err.resp_common.msg) return err.resp_common.msg
    },

    async handleVideoUpload($event) {
      const file = $event.file

      if (!file.name || !file.name.match(/\.(jpg|png|rar|zip|JPG|PNG|RAR|ZIP)$/gi)) {
        this.confirmDialogText = '请上传对应文件格式'
        return
      }

      if (file.size > this.fileMaxSize) {
        this.confirmDialogText = `上传的文件不能超过 ${Math.ceil(
          this.fileMaxSize / 1024 / 1024,
        )}M`
        return
      }

      this.encryptUpload(file)
    },

    async encryptUpload(file) {
      this.status = 'process'
      const data = new FormData()
      data.append('open_id', this.common.open_id)
      data.append('token', this.common.token)
      data.append('file', file)
      data.append('file_type', 'attachment')
      console.log(this.platform, "this.platform")
      try {
        const res = await encryptUpload(data, {}, this.platform)
        if (res.data) {
          this.resourceId = res.data.resource_id
          this.$emit('change', {
            resourceId: this.resourceId,
            preview: this.preview,
          })
          this.status = 'succ'
          this.$forceUpdate()
        }
      } catch (err) {
        this.status = 'wait'
        if (err.resp_common) {
          if (err.resp_common.ret === 4001002) {
            return
          }

          this.confirmDialogText = err.resp_common.msg
          return
        }

        this.confirmDialogText = err.message
      }
    },
    handleRemoveVideoResource() {
      this.resourceId = 0
      this.$emit('change', {
        resourceId: 0,
      })
      this.status = 'wait'
    },
  },
}
</script>
<style lang="scss" scoped>
.upload-other-label{
  font-size: 16px;
  color: #2c3e50;
}
.upload-other-label-vest{
  font-size: 14px;
  margin-bottom: 10px;
}
.upload-video-other {
  position: relative;
  width: 274px;
  height: 154px;

  .upload-info {
    margin: 55px 0 14px 0;
    font-weight: 700;
    font-size: 12px;
    color: #A5A5AE;
  }

  .upload-sub {
    font-size: 12px;
    color: #A5A5AE;
    ;

    .btn {
      display: inline-block;
      width: 45px;
      height: 20px;
      margin: 0 5px;
      line-height: 20px;
      text-align: center;
      font-weight: 700;
      background: #f5b903;
      border-radius: 2px;
      color: #333;
    }
  }

  .upload-tip {
    margin-top: 80px;
    font-size: 12px;
    font-weight: 700;
    color: #a5a5a5;
  }
}

.upload-video-process {
  position: relative;
  width: 274px;
  height: 154px;
  background: #F3F3F4 !important;
  // border: 2px dashed #a5a5a5;

  .upload-process-text {
    position: absolute;
    left: 0;
    right: 0;
    top: 70px;
    text-align: center;
    font-size: 16px;
    color: #A5A5AE;
  }

  .upload-speed {
    position: absolute;
    left: 0;
    right: 0;
    top: 266px;
    text-align: center;
    font-size: 12px;
    color: #a5a5a5;
  }
}

.upload-video-succ {
  position: relative;
  width: 274px;
  height: 154px;

  &::after {
    content: '';
    z-index: 1;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background: rgba(245, 185, 3, .3);
  }

  .pic {
    width: 100%;
    height: 100%;
    overflow: hidden;
    background-position: center;
    background-repeat: no-repeat;
    background-size: contain;
    opacity: .2;
  }

  .btn-remove {
    z-index: 2;
    position: absolute;
    right: 6px;
    top: 6px;
    width: 28px;
    height: 28px;
    line-height: 28px;
    text-align: center;
    font-size: 14px;
    background: #333;
    border-radius: 4px;
    color: #999;
    cursor: pointer;
  }

  .icon-upload-succ {
    z-index: 2;
    position: absolute;
    left: 50%;
    top: 50%;
    width: 100px;
    height: 107px;
    margin: -50px 0 0 -50px;
    background: url('~@/assets/images/icon-upload-succ.png') 0 0 no-repeat;
    background-size: 100%;
  }

  .upload-succ-text {
    z-index: 2;
    position: absolute;
    top: 115px;
    left: 0;
    right: 0;
    text-align: center;
    // font-weight: 700;
    font-size: 12px;
    color: #333;
  }
}

.loading-progress {
  position: absolute;
  left: 162px;
  top: 47px;
}

.confirm-dalog-wrap {
  &::before {
    content: '';
    z-index: 9;
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
  }
}

.el-select {
  display: block;
}

.flex-row {
  display: flex;
}
</style>

<style lang="scss">
.upload-video-other .el-upload .el-upload-dragger {
  background: #F3F3F4 !important;
  border-radius: 0;
}

.el-radio__label {
  font-size: 12px;
}

.el-input__inner {
  background: #F3F3F4;
}

.el-upload-dragger {

  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  width: auto;
  height: auto;
  border: none;
  outline: none;
  border-radius: 0;

  &.is-dragover {
    border: none;
  }
}

.el-upload__tip {
  display: none;
}

.el-upload-list {
  display: none;
}

.confirm .el-checkbox__label {
  font-size: 12px;
}

.fs {
  font-size: 14px;
  font-weight: 400;
  color: #333333;
  height: 15px;
  line-height: 24px;
}

.bar {
  position: absolute;
  z-index: 999;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(#000, .5);
}

.up-auth-dialog {
  position: absolute;
  z-index: 1000;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>